module.exports = __webpack_public_path__ + "img/register-company-details.3be59917.svg";